import type { ReactElement } from 'react'
import { ViewMapSetModal } from '../../../../components/infrastructure/ViewMapSetModal'
import { ViewCollectionSetModal } from '../../../../components/infrastructure/ViewCollectionSetModal'
import { DeleteContextMenu } from '../../../../components/infrastructure/DeleteContextMenu'
import { DeleteConfirmationModal } from '../../../../components/infrastructure/DeleteConfirmationModal'
import type { CaseInfrastructureTabModalsProps } from '../CaseInfrastructureTabModals'

type SetModalsProps = Pick<
  CaseInfrastructureTabModalsProps,
  | 'endpoints'
  | 'mapSetIds'
  | 'showViewMapSetModal'
  | 'setShowViewMapSetModal'
  | 'removeManyFromMapSet'
  | 'clearMapSet'
  | 'collectionSetIds'
  | 'showViewCollectionSetModal'
  | 'setShowViewCollectionSetModal'
  | 'removeFromCollectionSet'
  | 'clearCollectionSet'
>

export function SetModalsGroup(props: SetModalsProps): ReactElement {
  const {
    endpoints,
    mapSetIds,
    showViewMapSetModal,
    setShowViewMapSetModal,
    removeManyFromMapSet,
    clearMapSet,
    collectionSetIds,
    showViewCollectionSetModal,
    setShowViewCollectionSetModal,
    removeFromCollectionSet,
    clearCollectionSet,
  } = props
  return (
    <>
      {showViewMapSetModal && (
        <ViewMapSetModal
          mapSetIds={mapSetIds}
          endpoints={endpoints}
          onClose={() => {
            setShowViewMapSetModal(false)
          }}
          onRemove={(id) => {
            removeManyFromMapSet([id])
          }}
          onRemoveMany={removeManyFromMapSet}
          onClear={() => void clearMapSet()}
        />
      )}
      {showViewCollectionSetModal && (
        <ViewCollectionSetModal
          collectionSetIds={collectionSetIds}
          endpoints={endpoints}
          onClose={() => {
            setShowViewCollectionSetModal(false)
          }}
          onRemove={(id) => {
            removeFromCollectionSet(id)
          }}
          onRemoveMany={(ids) => {
            ids.forEach((id) => {
              removeFromCollectionSet(id)
            })
          }}
          onClear={clearCollectionSet}
        />
      )}
    </>
  )
}

type DeleteModalsProps = Pick<
  CaseInfrastructureTabModalsProps,
  | 'selectionCount'
  | 'bulkDeleting'
  | 'deleteContextMenu'
  | 'setDeleteContextMenu'
  | 'deleteConfirmation'
  | 'setDeleteConfirmation'
  | 'handleDeleteSingle'
  | 'handleDeleteSelected'
  | 'handleBulkDelete'
>

export function DeleteModalsGroup(props: DeleteModalsProps): ReactElement {
  const {
    selectionCount,
    bulkDeleting,
    deleteContextMenu,
    setDeleteContextMenu,
    deleteConfirmation,
    setDeleteConfirmation,
    handleDeleteSingle,
    handleDeleteSelected,
    handleBulkDelete,
  } = props
  return (
    <>
      {deleteContextMenu && (
        <DeleteContextMenu
          x={deleteContextMenu.x}
          y={deleteContextMenu.y}
          hasSelection={selectionCount > 0}
          selectionCount={selectionCount}
          onClose={() => {
            setDeleteContextMenu(null)
          }}
          onDeleteSingle={() => {
            handleDeleteSingle(deleteContextMenu.endpoint)
            setDeleteContextMenu(null)
          }}
          onDeleteSelected={() => {
            handleDeleteSelected()
            setDeleteContextMenu(null)
          }}
        />
      )}
      {deleteConfirmation && (
        <DeleteConfirmationModal
          endpoints={deleteConfirmation.endpoints}
          onClose={() => {
            setDeleteConfirmation(null)
          }}
          onConfirm={handleBulkDelete}
          deleting={bulkDeleting}
        />
      )}
    </>
  )
}
